//Sector/Indust  components

import React from "react";

import reqwest from "reqwest";
import { Slider, Row, Col, Card, Select, Button, TreeSelect,Tag,Popover,Tooltip } from "antd";
import { connect } from "react-redux";
import { activateDatadic,activateDatadicbackup,activateFiname,activateChange,activateScreen,activateRecord,activatePath,activateGoing, activateUnivid,
  activateUnivtype,  } from "../redux";
import { CloseCircleTwoTone, PoweroffOutlined } from "@ant-design/icons";

const { Option } = Select;
const { SHOW_PARENT } = TreeSelect;

class DropdownsClass extends React.Component {
  constructor(props) {
    super(props);
    window.indst = []
    this.myRef = React.createRef();
    this.state = {
      pass: this.props.pass,
      id: this.props.id,
      data: [],
    };
   
  }

 

  enterClose(e) {
    

    this.props.datadic.FilterDic.columns[
      this.myRef.current.props.id
    ].selected = 0;
    this.props.datadic.FilterDic.columns[
      this.myRef.current.props.id
    ].selectedUI = 0;

    this.props.activateDatadic({ FilterDic: this.props.datadic.FilterDic });
    setTimeout(() =>  this.HandleReqcount(), 1*1000);
  }

  onChange = (e) => {
  
    

    console.log('AAAAAAAAAAAAA',e)
    console.log('CCCCC',this.myRef.current.props.id)
    this.props.datadic.FilterDic.columns[5].value=e;

   if (e.length !=0){
     
    this.props.datadic.FilterDic.columns[this.myRef.current.props.id].selected = 1;
   }else{
    this.props.datadic.FilterDic.columns[this.myRef.current.props.id].selected = 0;
    this.props.datadic.FilterDic.columns[this.myRef.current.props.id].value = "";
   }
 
    this.props.activateDatadic({ FilterDic: this.props.datadic.FilterDic });
    setTimeout(() =>  this.HandleReqcount(), 1*1000);
  };
  componentDidMount() {}


/* 
  st2.map((val, i) => {
    console.log(val)
          }); */

          
   
  enterClose(e) {
    if (this.state.filtermt==0){
   
      this.props.activateFiname('');


    }
  

    this.props.datadic.FilterDic.columns[this.myRef.current.props.id].value = "";
    this.props.datadic.FilterDic.columns[this.myRef.current.props.id].selected = 0;
    this.props.datadic.FilterDic.columns[this.myRef.current.props.id].selectedUI = 0;
    this.props.activateDatadic({ FilterDic: this.props.datadic.FilterDic });
    setTimeout(() =>  this.HandleReqcount(), 1*1000);
  }

  onDataUpdate = (data) => {
    this.setState(
      {
       
        lookingTickers: false,
      }   )
        this.props.activateRecord(data);
        
        this.props.activateScreen(false);
        this.props.activateGoing(false);
        
    
   
  }
  HandleReqcount() {
   
    this.props.activateScreen(true);
    
    const controller = new AbortController();
    
    const { signal } = controller;
    
   if (this.props.going==false) {
    
    var  requestOptions= '';
    this.props.activateScreen(true);
    if (this.props.univtype==1) {
    
       requestOptions = {
       method: "POST",
       headers: { "Content-Type": "application/json" },
       body: JSON.stringify({ tables: [this.props.datadic.FilterDic],  portfolioId : this.props.univid   }),
     };
   
    }
    
    if (this.props.univtype==2) {
       requestOptions = {
       method: "POST",
       headers: { "Content-Type": "application/json" },
       body: JSON.stringify({ tables: [this.props.datadic.FilterDic],  screenId : this.props.univid   }),
     };
   }
 
   if (this.props.univtype==0) {
     requestOptions = {
       method: "POST",
       headers: { "Content-Type": "application/json" },
       body: JSON.stringify({ tables: [this.props.datadic.FilterDic]    }),
     };
   }


    this.props.activateGoing(true);
    fetch(
      this.props.apppath + "/include/api/screener/ssfiltercount.cfm", 
      requestOptions
    )
      .then((response) => response.json())
      .then((data /*  this.props.activateStocks(data.filteredData ) */) =>
       this.onDataUpdate(data)
       
      )
      .then((data) => 1)
      .catch((error) => {
         
        this.props.activateScreen(false);
        this.props.activateGoing(false);
        this.setState(
          {
            lookingTickers: false,
          },
          () => {
            this.props.activateRecord("No Results");
          }
        );
      });
    }else{
     
     console.log(this.props.going)
    }
  }


  render() {
    if (this.props.datadic.FilterDic != undefined) {
      var treeData = [];
     
      this.props.datadic.FilterDic.columns.map((experience, i) => {
        if (experience.label == "Exchange") {
          
       
          experience.selection.map((experience2, i) => {
            treeData[i] = {
              title: experience2.exchange,
              value: experience2.exchange,
              key: experience2.exchange,
             /*  children: this.trg(experience2.sectorId), */
            };

     
            
          });
        }
      });

       

    }
     
 

   
    
  
 
    const tProps = {
      
      treeData,
      virtual: false,
      showSearch: false,
      value:Array.isArray(this.props.datadic.FilterDic.columns[5].value)==true?this.props.datadic.FilterDic.columns[5].value:[],
      onChange: this.onChange,
      treeCheckable: true,
      showCheckedStrategy: SHOW_PARENT,
      placeholder: "Please select",
      style: {
        width: "89%",
      },
    };
  
    const slidestyle = {
      width: "100%",
    };

    const closebutton = {
      float: "right",
    };

    const gridStyle = {
      //  float: "right",
      width: '100%',
   
        
      };
    return (
      <div style={slidestyle}>
        <Card>
        <Card.Grid style={gridStyle} className='movercard'>
        <Popover content={this.state.pass.definition} title={this.state.pass.label} placement="right">
        {this.state.pass.label}{" "} 
         </Popover>
         &nbsp;
          <Row>
            {" "}
            <Col span={20}></Col>
            <TreeSelect {...tProps} ref={this.myRef} id={this.state.id} />
            <Col span={2} style={{paddingRight: '4px'}}>
              {" "}
              <div style={closebutton}>
                {" "}
                <Tooltip placement="topLeft" title="Remove this filter" color={'#2db7f5'}> <Button
                  type="text"
                  icon={<CloseCircleTwoTone />}
                  onClick={() => this.enterClose(this.state.id)}
                ></Button></Tooltip>{" "}
              </div>{" "}
            </Col>
          </Row>
          </Card.Grid>
        </Card>
      </div>
    );
  }
}
 

const mapStateToProps = (state) => ({
  datadic: state.datadic,
  datadicbackup: state.datadicbackup,
  finame: state.finame,
  change: state.change,
  screen: state.screen,
  record: state.record,
  apppath: state.apppath,
  going: state.going,
  univid: state.univid,
  univtype: state.univtype,
});

const mapDispatchToProps = {
  activateDatadic,activateDatadicbackup,activateFiname,activateChange,activateScreen,activateRecord,activatePath, activateGoing, activateUnivid,
  activateUnivtype,
};

const Dropdowns = connect(
  mapStateToProps,
  mapDispatchToProps
)(DropdownsClass);

export default Dropdowns;

 